import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fileActions } from '../../store/actions/FileActions.js'
import { useNavigate, useLocation } from 'react-router-dom'

//// import { mainStyles, theme } from '../../styles'
// import { useStyles } from './GroupActorsStyles.js'
import { groupActorsFunctions } from './GroupActorsFunctions.js'

import SearchIcon from '@mui/icons-material/Search';

import {
    CustomCounterAppBar, UseImage, InputField,
    CustomLoadingOverlay
    , Buttons
} from '../../components'

import {
    IconButton,
    Typography
    , useTheme
} from '@mui/material'
import noResultImg from 'assets/DOC/img/NoResults.png'
import { useTranslation } from 'react-i18next'

export default function SearchGroupComponent(props) {
    const gridContainer = {} //mainStyles.gridStyle()
    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()
    const localStyles = {}//useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { t } = useTranslation();

    const [loadView, setLoadView] = useState(false)
    const [noResult, setNoResult] = useState(false)
    const [search, setSearch] = useState('')

    const auth = useSelector(state => state.Authentication)
    const groupSearch = useSelector(state => state.GroupSearch)
    const folioId = location.state.folioId

    const bodyToSearch = {
        File_Id: folioId,
        GroupCode: search
    }

    const searching = () => {
        console.log(bodyToSearch)
        dispatch(fileActions.GetActorByGroup(bodyToSearch))
        setLoadView(true)
    }

    const createNewGroup = () => {
        // const nextComponent = 'CreateGroupComponent'
        const nextComponent = 'GroupActorsComponent'
        groupActorsFunctions.nextStage({ auth, navigate, nextComponent, folioId })
    }

    useEffect(() => {
        if (groupSearch.items != undefined && loadView) {
            setLoadView(false)
            if (groupSearch.items?.GroupCode != null) {
                const nextComponent = 'GroupActorsComponent'
                groupActorsFunctions.nextStage({ auth, navigate, nextComponent, folioId })
            } else {
                setNoResult(true)
            }
        }
        if (groupSearch.error != undefined && loadView) {
            if (groupSearch.error == "La solicitud ya esta asociada a un grupo") {
                const nextComponent = 'GroupActorsComponent'
                groupActorsFunctions.nextStage({ auth, navigate, nextComponent, folioId })
            } else {
                alert(groupSearch.error)
                setLoadView(false)
            }
        }
    }, [groupSearch])

    return (
        <div className={gridContainer.container}>
            <div className={gridContainer.leftColumn}></div>
            <div className={gridContainer.centerColumn}>
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                {/* {loadView ? <LoadingOverlay
                    active={loadView}
                    spinner
                    text='Espere un momento por favor...'
                    className={classes.loader}>
                </LoadingOverlay> : null} */}
                <CustomCounterAppBar />
                <div className={gridContainer.centerContent1}>
                    <Typography variant="h6"
                        gutterBottom
                        
          ><b>Búsqueda por grupo</b></Typography>
                    <div className={localStyles.searchContainer}>
                        <InputField
                            fullWidth
                            size="small"
                            type='Number'
                            variant='outlined'
                            value={search}
                            onChange={(e) => {
                                console.log("search------------: ", e.target.value, search)
                                setSearch(e.target.value)
                            }}
                            className={localStyles.searchInput}
                            label='Ingresa la clave del grupo' />
                        <IconButton
                            disableRipple={true} size="small"
                            className={localStyles.searchIcon}
                            color="inherit"
                            onClick={searching}
                            aria-label="search">
                            <SearchIcon style={{ color: '#ffffff' }} />
                        </IconButton>
                    </div>
                    {noResult && <div className={localStyles.noResultSection}>
                        <UseImage width={'40%'} src={noResultImg} className={localStyles.noResultImg} />
                        <Typography variant='h6' className={localStyles.noResultText}><b>No se encontró el grupo.</b></Typography>
                        <Typography variant='subtitle1' className={localStyles.noResultText}>Crea un nuevo grupo presionando el botón crear.</Typography>
                    </div>}
                    {noResult && <Buttons
                        text_color="#FFFFFF"
                        background_color={theme.palette.primary.main}
                        border_color={theme.palette.primary.main}
                        text="Crear grupo"
                        type="button"
                        click={createNewGroup}
                    />}
                </div>

            </div>
            <div className={gridContainer.rightColumn}></div>
        </div>
    )
}